import * as _ from 'lodash';
import * as fetch from 'isomorphic-fetch';
import { Promise } from 'es6-promise';

declare var CRO_APP_CDN_DOMAIN_NO_BUILD;
declare var env: any;


class Range {
    public name: string;
    public min: number;
    public max: number;

    constructor(name: string, min: number, max: number) {
        this.name = name;
        this.min = min;
        this.max = max;
    }
}

export class OverallScoreHelper {
    private defaultRanges: Range[];

    constructor() {
        this.defaultRanges = [
            new Range('Excellent', 81, 100),
            new Range('Very good', 61, 80),
            new Range('Good', 41, 60),
            new Range('Fair', 21, 40),
            new Range('Poor', 0, 20)
        ];
    }

    public getOverallScoreType(overallScore: number, surveyColorRange?: string, configuredRanges?: Range[]): string {
        if (surveyColorRange) {
            return this.convertNameToSlug(surveyColorRange);
        }

        const ranges = _.isEmpty(configuredRanges) ? this.defaultRanges : configuredRanges;
        const {name = null} = _.find(ranges, ({min, max}) => overallScore >= min && overallScore <= max);

        return this.convertNameToSlug(name);
    }

    public getTestState(overallScore: number, isTested: boolean): string {
        if (isTested) {
            return 'tested';
        } else if (overallScore == 0) {
            return 'in test';
        } else {
            return 'not tested';
        }
    }

    private convertNameToSlug(value: string): string {
        if (typeof value !== 'string') {
            return 'default';
        }

        return value.toLowerCase().replace(' ', '-');
    }
}

export class ImageURLHelper {
    public getImageURL(imageURL: string): string {
        // CRO_APP_CDN_DOMAIN_NO_BUILD injected in the blade controller

        if (~imageURL.indexOf('missing-product-image-thumbnail.jpg') || ~imageURL.indexOf('missing-product-image.jpg')) {
            return CRO_APP_CDN_DOMAIN_NO_BUILD + 'images/no_image.svg';
        }

        return imageURL;
    }

    public getImageURLNew(imageObj: object): string {
        // new products api contains a profileImage object that will allow us to generate and return the 
        // cloudinary image file path/name
        let imageWidth = 240;
        let imageExt = 'png';
        let format = imageObj['fileFormat'] || imageExt;
        return imageObj['cloudFrontDomain'] +
            '/c_lfill,w_' +
            imageWidth +
            imageObj['relativePath'] +
            imageObj['fileName'] +
            '.' +
            format;
    }
}

export function getSubscriptionInfo(): Promise<any> {
    const url = env['DRS_USER_INFO_URL'];
    return fetch(url,
        {
            credentials: 'same-origin',
        })
        .then((response) => response.json())
        .catch((error) => {
            console.log('Error: ' + error);
            throw new Error('Error: ' + error); // DONT HIDE
        });
}

export function isArchiveModel(availability: string): boolean {
    return availability === 'Discontinued, Similars Avail.' || availability === 'Discontinued, Not Avail.';
}

export function truncateStringWithEllipsis(text: string, trimCount = 0, ellipsis = '...'): string {
    return (text && text.length && trimCount > 0 && text.length > trimCount)
        ? text.substr(0, trimCount - ellipsis.length) + ellipsis
        : text;
}

export function getSubCategorySortOrderMap(subcategories: any[]): Object {
    if (!subcategories || !subcategories.length) return [];

    return subcategories.map(function (subcategory) {
        if (subcategory.singularName && subcategory.sortOrder) {
            return {
                sortOder: subcategory.sortOrder,
                singularName: subcategory.singularName,
                pluralName: subcategory.pluralName,
            };
        }
    }).filter(Boolean);
}

export function convertDigitToWord(digit: number): string {
    const digitWords = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
    return _.get(digitWords, digit, '');
}



// WEBPACK FOOTER //
// ./resources/modules/shared/helpers/HelperFunctions.ts